<style lang="less" scoped>
  @import '../../styles/main.less';
  /deep/ .ivu-tag-dot{
    border-radius: 22px !important;
    background-color: #F3F3F3 !important;
    margin: 5px 5px 5px 0px;
    height: 28px;
    line-height: 26px;
    font-size: 14px;
    font-weight: 500;
  }
  /deep/ .ivu-tag-checked .ivu-tag-text{
    color: #2d8cf0;
  }
  /deep/ .ivu-tag-default .ivu-tag-text{
    color: #666666;
  }
  /deep/ .ivu-tag-dot-inner{
    display: none;
  }
  .label-font-black {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .label-font-white {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
  }
</style>

<template>
  <div ref="scrollCon" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll" class="tags-outer-scroll-con">
    <div class="close-all-tag-con">
      <Tooltip :transfer=true>
        <Tag class="close-all-tag-con-all close-all-tag-con-all-font" @click.native="closeOther">关闭其他</Tag>
        <div slot="content">
          <p class="tooltip-text">关闭“本页”和“首页”</p>
          <p class="tooltip-text">以外的其他页面</p>
        </div>
      </Tooltip>
      <Tooltip :transfer=true>
        <Tag class="close-all-tag-con-all close-all-tag-con-all-font" @click.native="closeAll">关闭所有</Tag>
        <div slot="content">
          <p class="tooltip-text">关闭“首页”</p>
          <p class="tooltip-text">以外的其他页面</p>
        </div>
      </Tooltip>

<!--      <Dropdown transfer @on-click="handleTagsOption">-->
<!--        <Button size="small" type="primary">-->
<!--          <span class="label-font-white">标签选项</span>-->
<!--          <Icon type="arrow-down-b"></Icon>-->
<!--        </Button>-->
<!--        <DropdownMenu slot="list">-->
<!--          <DropdownItem name="clearAll"><span class="label-font-black">关闭所有</span></DropdownItem>-->
<!--          <DropdownItem name="clearOthers"><span class="label-font-black">关闭其他</span></DropdownItem>-->
<!--        </DropdownMenu>-->
<!--      </Dropdown>-->
    </div>
    <div ref="scrollBody" class="tags-inner-scroll-body" :style="{left: tagBodyLeft + 'px'}">
      <transition-group name="taglist-moving-animation">
        <Tag
          type="dot"
          v-for="(item) in pageTagsList"
          ref="tagsPageOpened"
          :key="item.name"
          :name="item.name"
          @on-close="closePage"
          @click.native="linkTo(item)"
          :closable="item.name!=='HomeIndex'"
          :color="item.children?(item.children[0].name===currentPageName?'blue':'default'):(item.name===currentPageName?'blue':'default')"
        >{{ itemTitle(item) }}
        </Tag>
      </transition-group>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tagsPageOpened',
    data () {
      return {
        currentPageName: this.$route.name,
        tagBodyLeft: 0,
        tagConWidth: 210, // '关闭xx'按钮组的宽度, 用于决定tags的位置
        refsTag: [],
        tagsCount: 1
      }
    },
    props: {
      pageTagsList: Array,
      beforePush: {
        type: Function,
        default: (item) => {
          return true
        }
      }
    },
    computed: {
      title () {
        return this.$store.state.app.currentTitle
      },
      tagsList () {
        return this.$store.state.app.pageOpenedList
      }
    },
    methods: {
      itemTitle (item) {
        if (typeof item.title === 'object') {
          return this.$t(item.title.i18n)
        } else {
          return item.title
        }
      },
      closePage (event, name) {
        let pageOpenedList = this.$store.state.app.pageOpenedList
        let lastPageObj = pageOpenedList[0]
        if (this.currentPageName === name) {
          let len = pageOpenedList.length
          for (let i = 1; i < len; i++) {
            if (pageOpenedList[i].name === name) {
              if (i < (len - 1)) {
                lastPageObj = pageOpenedList[i + 1]
              } else {
                lastPageObj = pageOpenedList[i - 1]
              }
              break
            }
          }
        } else {
          let tagWidth = event.target.parentNode.offsetWidth
          this.tagBodyLeft = Math.min(this.tagBodyLeft + tagWidth, 0)
        }
        this.$store.commit('removeTag', name)
        this.$store.commit('closePage', name)
        pageOpenedList = this.$store.state.app.pageOpenedList
        localStorage.pageOpenedList = JSON.stringify(pageOpenedList)
        if (this.currentPageName === name) {
          this.linkTo(lastPageObj)
        }
      },
      linkTo (item) {
        let routerObj = {}
        routerObj.name = item.name
        if (item.argu) {
          routerObj.params = item.argu
        }
        if (item.query) {
          routerObj.query = item.query
        }
        if (this.beforePush(item)) {
          this.$router.push(routerObj)
        }
      },
      handlescroll (e) {
        var type = e.type
        let delta = 0
        if (type === 'DOMMouseScroll' || type === 'mousewheel') {
          delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40
        }
        let left = 0
        if (delta > 0) {
          left = Math.min(0, this.tagBodyLeft + delta)
        } else {
          if (this.$refs.scrollCon.offsetWidth - this.tagConWidth < this.$refs.scrollBody.offsetWidth) {
            if (this.tagBodyLeft < -(this.$refs.scrollBody.offsetWidth - this.$refs.scrollCon.offsetWidth + this.tagConWidth)) {
              left = this.tagBodyLeft
            } else {
              left = Math.max(this.tagBodyLeft + delta, this.$refs.scrollCon.offsetWidth - this.$refs.scrollBody.offsetWidth - this.tagConWidth)
            }
          } else {
            this.tagBodyLeft = 0
          }
        }
        this.tagBodyLeft = left
      },
      handleTagsOption (type) {
        if (type === 'clearAll') {
          this.$store.commit('clearAllTags')
          this.$router.push({
            name: 'HomeIndex'
          })
        } else {
          this.$store.commit('clearOtherTags', this)
        }
        this.tagBodyLeft = 0
      },
      closeOther () {
        this.$store.commit('clearOtherTags', this)
      },
      closeAll () {
        this.$store.commit('clearAllTags')
        this.$router.push({
          name: 'HomeIndex'
        })
      },
      moveToView (tag) {
        if (tag.offsetLeft < -this.tagBodyLeft) {
          // 标签在可视区域左侧
          this.tagBodyLeft = -tag.offsetLeft + 10
        } else if (tag.offsetLeft + 10 > -this.tagBodyLeft && tag.offsetLeft + tag.offsetWidth < -this.tagBodyLeft + this.$refs.scrollCon.offsetWidth - this.tagConWidth) {
          // 标签在可视区域
          this.tagBodyLeft = Math.min(0, this.$refs.scrollCon.offsetWidth - this.tagConWidth - tag.offsetWidth - tag.offsetLeft - 20)
        } else {
          // 标签在可视区域右侧
          this.tagBodyLeft = -(tag.offsetLeft - (this.$refs.scrollCon.offsetWidth - this.tagConWidth - tag.offsetWidth) + 20)
        }
      }
    },
    mounted () {
      this.refsTag = this.$refs.tagsPageOpened
      setTimeout(() => {
        this.refsTag.forEach((item, index) => {
          if (this.$route.name === item.name) {
            let tag = this.refsTag[index].$el
            this.moveToView(tag)
          }
        })
      }, 1) // 这里不设定时器就会有偏移bug
      this.tagsCount = this.tagsList.length
    },
    watch: {
      '$route' (to) {
        this.currentPageName = to.name
        this.$nextTick(() => {
          this.refsTag.forEach((item, index) => {
            if (to.name === item.name) {
              let tag = this.refsTag[index].$el
              this.moveToView(tag)
            }
          })
        })
        this.tagsCount = this.tagsList.length
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/components/tags-page-opened.vue